
import Vue from "vue";
import $ from "jquery";
import Component from "vue-class-component";
import { State } from "vuex-class";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class AppNavbarSecondary1 extends Vue {
  @State("school", { namespace: "school" })
  private school!: any;
  @State("template", { namespace: "school" })
  private template!: any;

  @Prop({ default: false })
  private mobileMenu!: boolean;
  @Prop({ default: null })
  private goHome!: any;
  @Prop({ default: null })
  private onMoreNews!: any;
  @Prop({ default: null })
  private onNavigateJobFair!: any;
  @Prop({ default: null })
  private onClick!: any;

  @Watch("mobileMenu")
  private listenShowMobileMenu(v: boolean) {
    if (v) {
      let div = document.createElement("div") as any;
      div.classList = "custom-navbar-menu-backdrop";
      div.addEventListener("click", this.toggleShowNavbarMobileMenu);
      div.click = this.toggleShowNavbarMobileMenu;
      document.getElementById("nav-mobile")?.appendChild(div);
    } else {
      document.querySelector(".custom-navbar-menu-backdrop")?.remove();
    }
  }

  private toggleShowNavbarMobileMenu(e: any) {
    const isContainer = $(e.target).closest(".nav-mobile-menu").length;
    if (!isContainer) {
      this.$emit("update:mobileMenu", !this.mobileMenu);
      document.querySelector(".custom-navbar-menu-backdrop")?.remove();
    }
  }
}
